var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.8108C20.8424 14.5166 20.2022 16.1423 19.1543 17.4975C18.1065 18.8528 16.6944 19.8816 15.0832 20.4636C13.4719 21.0456 11.7283 21.1566 10.0563 20.7838C8.38426 20.411 6.85298 19.5697 5.64164 18.3584C4.43031 17.147 3.589 15.6157 3.21618 13.9437C2.84336 12.2717 2.95443 10.5281 3.53641 8.91685C4.11839 7.30564 5.1472 5.8935 6.50246 4.84567C7.85772 3.79783 9.48337 3.15764 11.1892 3C10.1905 4.35113 9.7099 6.01585 9.83485 7.69137C9.95979 9.36689 10.682 10.9419 11.87 12.13C13.0581 13.318 14.6331 14.0402 16.3086 14.1652C17.9842 14.2901 19.6489 13.8095 21 12.8108Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.cbf0a5e3e1e5c881fef579c71fef821e.svg";
export { ForwardRef as ReactComponent };